__turbopack_context__.v({
  "button": "work_pilars-module__T5BeCa__button",
  "button_container": "work_pilars-module__T5BeCa__button_container",
  "work_pilar_item": "work_pilars-module__T5BeCa__work_pilar_item",
  "work_pilar_item__description": "work_pilars-module__T5BeCa__work_pilar_item__description",
  "work_pilar_item__image": "work_pilars-module__T5BeCa__work_pilar_item__image",
  "work_pilar_item__title": "work_pilars-module__T5BeCa__work_pilar_item__title",
  "work_pilars": "work_pilars-module__T5BeCa__work_pilars",
  "work_pilars__items": "work_pilars-module__T5BeCa__work_pilars__items",
  "work_pilars_title": "work_pilars-module__T5BeCa__work_pilars_title",
});
